import companySlice from './companySlice'
export default companySlice.reducer
